import DOMPurify from 'dompurify';
import { HTMLAttributes, useMemo } from 'react';

export type HtmlBlockProps = {
  htmlString: string;
  tag?: 'div' | 'p' | 'script';
  type?: string;
} & HTMLAttributes<HTMLElement>;

export const HtmlBlock = ({
  htmlString,
  tag: Tag = 'div',
  type,
  ...props
}: HtmlBlockProps) => {
  const isScript = Tag === 'script';

  const htmlContent = useMemo(() => {
    if (typeof window === 'undefined') {
      return htmlString;
    }
    return isScript ? htmlString : DOMPurify.sanitize(htmlString);
  }, [htmlString, isScript]);

  return (
    <Tag
      type={isScript ? type || 'text/javascript' : undefined}
      // eslint-disable-next-line @eslint-react/dom-no-dangerously-set-innerhtml
      dangerouslySetInnerHTML={{ __html: htmlContent }}
      {...props}
    />
  );
};
